import { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react';
import moment from 'moment';
import TabNav from '../../../components/atom/TabNav';
import Aux from '../../../components/atom/children';
import Banner from '../../../components/molecules/BannerTitle';
import Container from '../../../components/atom/container/conatinerfull';
import Tablink from '../../../components/molecules/Tab/leftTab';
import Notfound from '../../../components/atom/notFound';
import DownlaodView from '../../../components/molecules/download/index';
import Searchicon from '../../../components/molecules/download/search';
import { regEx } from '../../../helper/constant';
import { DateRange } from '../../../helper/validation';
import Prelogin from '../../../services/preLoginApi';

let api = new Prelogin();
let tabLinkMain = [
  // { name: "Mutual Funds", active: "mutualfund", url: "/Download/mutualfund/totalExpense" },
  // { name: "Portfolio Management Services", active: "PMS", url: "/Download/pms/Forms" },
];
let tabLink = [
  { name: "Presentations", link: "Presentations", apiKey: "Presentations" },
  { name: "Monthly Communique", link: "monthlyCommunique", apiKey: "Monthly_Communique" },
  { name: "Document", link: "Document", apiKey: "Document" },
  { name: "Leaflet/Brochure", link: "Leaflet_Brochure", apiKey: "Leaflet_Brochure" },
  { name: "Forms", link: "Forms", apiKey: "Forms" },
  { name: "Regulatory Updates", link: "Regulatory_Updates", apiKey: "Regulatory_Updates" },
]


const Download = (props) => {
  const router = useRouter()
  let allDownload = props.apiData;
  const { pid } = router.query;
  let active = "PMS";
  let sebipdf = '/assets/pdf/Investor_Charter_PMS_Website_Upload.pdf';

  var startDateSearch = new Date();
  startDateSearch.setMonth(startDateSearch.getMonth() - 1);
  const [tab, setTab] = useState([]);
  const [activeTab, setActiveTab] = useState('');//active left tab
  const [paramUrl, setParamUrl] = useState(null);
  // const [allDownload, setAllDownload] = useState(null);
  const [apiData, setApiData] = useState([]);
  const [listData, setListData] = useState([]);
  // const [state, setState] = useState({ schameName: "", startDOB: "", endDOB: "" });
  const [state, setState] = useState({ schameName: "", startDOB: startDateSearch, endDOB: new Date() });
  const [error, setError] = useState({});
  const [defaultActive, setDefaultActive] = useState(true);
  const [btnLoader, setBtnLoader] = useState(false);
  let [keyData, setKeyData] = useState({});//keyswiseData
  let [singleData, setSingleData] = useState([]);
  const changeHandler = (name, value) => {
    let allState = state;
    let validationRegx = /^[a-zA-Z0-9 ]*$/;
    if (name === "schameName") {
      if (validationRegx.test(value)) {
        allState[name] = value;
      }
    } else {
      allState[name] = value;
    }
    setState({ ...allState })
  }

  useEffect(() => {
    // if(defaultActive){
    let { id } = pid;
    tabLink.map((curr, index) => {
      if (curr.link === id) {
        setParamUrl(curr.apiKey);
        setActiveTab(curr.name)
      }
    })
  }, [activeTab])

  const validate = (name, value) => {
    let type = name;
    let errorMsg = { ...error };
    if (type === "schameName") {
      let alphabatesWithSpace = regEx.alphaNumericWithSingleSpace;
      if (!alphabatesWithSpace.test(value)) {
        errorMsg['schameNameError'] = "Please enter a valid name";
      } else {
        errorMsg['schameNameError'] = "";
      }
      setError(errorMsg)
    }
    if (type === "startDOB") {
      let strDate = DateRange(value);
      if (!strDate.res) {
        errorMsg['startDOBError'] = strDate.msg
      } else {
        errorMsg['startDOBError'] = ""
      }
      setError(errorMsg)
    }
    if (type === "endDOB") {
      let endDate = DateRange(value);
      if (!endDate.res) {
        errorMsg['endDOBError'] = endDate.msg
      } else {
        errorMsg['endDOBError'] = ""
      }
      setError(errorMsg)
    }
  }

  const gofilter = () => {
    let check = Formvalidate();
    if (check) {
      setBtnLoader(true);
      let { schameName, startDOB, endDOB } = state;
      let strtDate = moment(startDOB, 'DD/MM/YYYY').format("DD/MM/YYYY")
      let endDate = moment(endDOB, 'DD/MM/YYYY').format("DD/MM/YYYY")
      let payload = {
        "api_name": "SearchDownloads",
        "pagename": paramUrl,
        "FilterTxt": schameName,
        "SchCode": "",
        "FromDate": endDate,
        "ToDate": strtDate,
        "from": "PMS"
      }

      api.SearchDownloads(payload).then(res => {
        let result = res.data.data;
        if (res.data.success) {
          setBtnLoader(false);
          setListData(result);
          setSingleData(result);
        } else {
          setBtnLoader(false);
          setListData(result);
          setSingleData(result);
        }
      })
    }
  }

  useEffect(() => {
    if (allDownload !== null) {
      let checkExist = paramUrl in allDownload;
      if (checkExist) {
        let data = allDownload[paramUrl];
        setListData(data)
      }
    }
  }, [paramUrl, allDownload])

  useEffect(() => {
    if (allDownload !== null) {
      let namekeyAarry = [];
      let kyWiseData = [];

      allDownload['PMS'].map((curr, index) => {
        if (index === 0) {
          if (defaultActive) {
            setActiveTab(curr.name)
          }
        }
        if (namekeyAarry.indexOf(curr.name) === -1) {
          namekeyAarry.push(curr.name)
          kyWiseData.push({ name: curr.name })
        }

      })
      //   kyWiseData.push({
      //     name: "Investor Charter"
      //   })
      setTab(kyWiseData)

      if (namekeyAarry.length > 0) {
        let keyData = {};
        namekeyAarry.forEach((ele, index) => {
          let data = [];
          allDownload['PMS'].map((curr, index) => {
            if (curr.name === ele) {
              data.push(curr)
            }
          })
          keyData[ele] = data
        })
        setKeyData(keyData)
      }
    }
  }, [allDownload])

  useEffect(() => {
    if (Object.keys(keyData).length > 0) {
      if (activeTab !== "Investor Charter") {
        let getData = keyData[activeTab];
        setSingleData(getData)
      } else {
        setSingleData([]);
      }
    }
  }, [activeTab, keyData])

  const dateFormat = (validDate) => {
    let data = new Date(validDate)
    let fullyear = data.getFullYear();
    let fullDate = data.getDate();
    let getMonth = data.getMonth() + 1;
    let pDate = fullDate.toString().length > 1 ? fullDate.toString() : "0" + fullDate.toString();
    let pMonth = getMonth.toString().length > 1 ? getMonth.toString() : "0" + getMonth.toString();
    return pDate + "/" + pMonth + "/" + fullyear.toString();
  }

  const Formvalidate = () => {
    let { schameName, startDOB, endDOB } = state;
    let stData = dateFormat(startDOB);
    let endData = dateFormat(endDOB);
    let strDate = DateRange(stData);
    let endDate = DateRange(endData)
    let alphabatesWithSpace = regEx.alphaNumericWithSingleSpace;
    let errorMsg = { ...error };
    let isflag = false;
    if (schameName === "") {
      errorMsg['schameNameError'] = "Please enter value";
    } else if (!alphabatesWithSpace.test(schameName)) {
      errorMsg['schameNameError'] = "Please enter a valid name";
    } else if (!strDate.res) {
      errorMsg['startDOBError'] = strDate.msg
    } else if (!endDate.res) {
      errorMsg['endDOBError'] = endDate.msg
    }
    //    else if (endData < stData) {
    //       errorMsg['endDOBError'] = "End date can not be less then start date."
    //   } 
    else {
      isflag = true;
      errorMsg['schameNameError'] = "";
      errorMsg['startDOBError'] = "";
      errorMsg['endDOBError'] = "";
    }
    console.log(errorMsg, 'errorMsg')
    setError(errorMsg)
    return isflag;
  }

  const tabClick = (data) => {
    let redire_url = "";
    tabLink.map((curr, index) => {
      if (curr.name === data) {
        router.push(`/download/pms/${curr.link}`);
        setActiveTab(curr.name);
        setParamUrl(curr.apiKey)
        setDefaultActive(false);
      }
    })
  }

  const [optionShow, setOptionShow] = useState(null);

  const showDownloadPopup = (someId) => {
    setOptionShow(someId);
  }

  const hideDownloadPopup = () => {
    setOptionShow(null);
  }

  return (
    <>
      <Aux>
        <Banner
          image="/assets/images/download/banner.svg"
          title="Downloads"
          imgClass="full_imge"
          class=""
          headingClass="bannerHeading"
        />
        <div className="col-md-12 padd0 text-center">
          <TabNav data={tabLinkMain} active={active} />
        </div>
      </Aux>
      <Container>
        <div className="col-md-12 col-sm-12 col-xs-12">
          <div className="row">
            <Tablink tabArray={tab} activeTab={activeTab} activeClick={tabClick}>
              {activeTab === "Investor Charter" ?
                <>
                  <DownlaodView

                    date={""}
                    docName={"Investor Charter for PMS"}
                    file={sebipdf}
                    fileType={"pdf"}
                    isEditable={"0"}
                    optionShow={optionShow}
                    showDownloadPopup={showDownloadPopup}
                    hideDownloadPopup={hideDownloadPopup}
                  />
                </> :
                <>
                  {singleData.length > 0 ?

                    <Searchicon
                      error={error}
                      state={state}
                      loader={btnLoader}
                      validate={validate}
                      btnClick={gofilter}
                      onChange={changeHandler} /> : null}
                  {/* <Notfound msg="Data not available"/> */}

                  {singleData.length > 0 ?
                    <div className="row">
                      {singleData.map((curr, index) => {
                        return (
                          <DownlaodView
                            key={index}
                            date={curr.publishDate}
                            docName={curr.DocumentName}
                            file={curr.file}
                            fileType={curr.fileType}
                            optionShow={optionShow}
                            showDownloadPopup={showDownloadPopup}
                            hideDownloadPopup={hideDownloadPopup}
                          />
                        )
                      })}
                    </div> : <div className="col-md-12  clearfix"><Notfound class="text center" msg="Not  found" /></div>}
                </>}
            </Tablink>
          </div>
        </div>
      </Container>
    </>
  )
}

export async function getServerSideProps(req, res) {
  const { pid } = req.query;
  let Alldata = {};
  let payload = {
    "api_name": "getDownloads"
  }
  let response = await api.download(payload);
  if (response.data.success) {
    Alldata = response.data.data
  } else {
    Alldata = {};
  }
  return {
    props: {
      apiData: Alldata
    }
  }
}

export default Download